export default "__VITE_ASSET__37883dd9__"